export const getDefaultManualFilterState = () => {
    return {
        title: "",
        createdAt: {
            start: "",
            end: ""
        },
        company: "",
        branch: "",
        direction: "",
        responsibleForImplementationUserId: "",
        ownerId: "",
        responsibleUserId: "",
        status: "",
        category: ""
    }
}